const keyRoute = "@route/route-from";

/**
 * @returns {{ value: Object.<string, any> }}
 */
export function Route() {
  const parsedValue = JSON.parse(localStorage.getItem(keyRoute) || "{}");
  const source = { value: parsedValue };

  return new Proxy(source, {
    get(target, property) {
      return target[property];
    },
    set(target, property, newValue) {
      const stringiedRoute = JSON.stringify(newValue);
      localStorage.setItem(keyRoute, stringiedRoute);
      target[property] = newValue;
      return true;
    },
  });
}

export function setRoute(route = {}) {
  const router = Route();
  router.value = route;
}

export const routeFrom = () => {
  const route_from = JSON.parse(localStorage.getItem(keyRoute) || "{}");
  return route_from;
};

export function routeToCache(route) {
  const backRoute = Route();
  if (backRoute.value.name !== route.name) {
    return backRoute.value;
  }
  return route;
}

export const routeBack = (route_name, query = {}, params = {}) => {
  const route_data = Route();
  if (route_data.value.name != route_name) {
    return {
      name: route_name,
      query: query,
      params: params,
    };
  }
  return route_data.value;
};

export default { routeFrom, routeBack };
